import React from 'react';
import { config } from '@triare/auth-redux';
import Layout from '../../../components/Layout';
import Content from '../../../components/Pages/Admins/View';

const { displayName } = config;

export default function AdminEdit(): React.ReactNode | null {
  document.title = `${displayName}: Admin view`;

  return (
    <Layout
      title="Admin view"
    >
      <Content />
    </Layout>
  );
}
